import axios from "axios";
import {API, basePath, TEST_ENV} from ".";
import axiosData from "../helpers/axiosData";

export const get = (url, callback) => {

    const xhr = new XMLHttpRequest()
    //open a get request with the remote server URL
    xhr.open("GET", url)
    //send the Http request
    xhr.send()

    //triggered when the response is completed
    xhr.onload = function() {
        if (xhr.status === 200) {
            //parse JSON data
            let data = xhr.responseText
            callback(data)
        } else if (xhr.status === 404) {
            // console.log("No records found")
        }
    }
}

export const redirectTo = (url) => {
        
    // let root_ = basePath + url; 
    // root_ = root_.replace((basePath+basePath), basePath);
    //  console.log( 'url', url, ', basePath', basePath, ', root_', root_, 'window.location.href', window.location.pathname)

    if ( url !== window.location.pathname ) {
        window.location.href = url;
    }
}

export const getItems = (key, is_array) => {

    let item = localStorage.getItem(key);

    try{ item =  JSON.parse(item); } catch(err) { /*console.log('err parse', err);*/ item = []; }
    // console.log('item === ', item != null ,'&&', item != 'null' ,'&&', item != '', '&&', (typeof item.length != 'undefined'), typeof item == 'object' )

    item = item != null && item != 'null' && item != '' && (typeof item == 'object' || typeof item.length != 'undefined') ? item : (is_array?[]:{});
    // console.log('item => ', item)

    return item;
}

/*-----------------------*/
export const getRectSelecteds = (return_array) => {

    let items = getItems('selectedrects', return_array)

    if(return_array) {

        let items_ = [];

        for (let i in items) {
            items_.push(i)
        }

        return items_;
    }

    return items;
}

export const updateUserAccount = (account) => {
    
    alert('You don`t connect wallet. For continue connect wallet');
    /* axiosData
    .post(`/api/_web3/user/settings/`, {account:account})
    .then((res) => {
       console.log('response', res);
    })
   .catch((error) => {
   console.log('put error: ', error)
       // setErrors(error.response.data.errors);
       // toast.error(error.response.data.message);
   })
   .finally(); */
}

export const getAppSettings = (callback=()=>{}) => {

    axiosData
    .get(`/api/_web3/user/app-settings/`)
    .then((res) => {
        callback (res.data.data);
    })
   .catch((error) => {
        console.log('error: ', error)
        callback ({});
   })
}


/*---------------------------*/
export const saveBuyedNFT = (account, items='') => {

    if (items !== '') {

        get(API+'?account='+account+'&items='+items, function(data) {
            // console.log('data', data)
        });
    }

    

    axiosData.get(`/api/_web3/land-buy/${account}`)
    .then((res) => {
    //    console.log('response land-buy ', res);
    })
   .catch((error) => {
        console.log('put error: ', error)
       // setErrors(error.response.data.errors);
       // toast.error(error.response.data.message);
   })
   .finally((data) => {console.log('final data', data)});
    
 
    // https://app.metafluence.com/api/v1/public/api/_web3/land-buy/0x74322856849113bC99943b7adA7B3ed4f4518415
}



// 


export const log_ = (data) => {
    if (TEST_ENV == 0) {
        get(API+'log.php?account='+getCookie('account')+'&data='+JSON.stringify(data), function(result) {
            let dat = JSON.parse(result);
        });
    }
}


export const getCookie = (cookie_) => {
    let Cookies = document.cookie;
    if(Cookies != '' && Cookies.indexOf(cookie_ + '=') > -1) {
        let SpCookie = Cookies.split(cookie_ + '=');
        let Cookie = SpCookie[1].split(';')[0];
        return Cookie;
    }

    return '';
}

export const setCookie = (cookie_, val_, expire=0) => {
    let date_1 = new Date(); 
    date_1.setDate(date_1.getDate()+(expire ? -365 : 365));
    date_1.getFullYear()

    document.cookie = cookie_ + "=" + val_ + "; expires="+date_1.toUTCString()+"; path=/"; //Thu, 18 Dec 2023 12:00:00 UTC

    return true;
}



export const C = (w,percent) => {

    let transform = document.getElementById('panzom-panned').style.transform;

    transform = transform.replace('matrix(', '').replace(')', '').replace(' ', '').split(',')

    let dif = 1.3-parseFloat(transform[0]);

    let resultd =  w + (dif*w)

    percent = typeof percent != 'undefined' ? percent : -.21;
    // console.log('percent', percent)
    return resultd+(resultd*percent);

}
